﻿import { MainNavigation } from './main-navigation';
import { LanguageSelector } from './language-selector';
import { BackgroundMedia } from './background-media';
import { SwiperContainer } from './swiper-container';
import { Video } from './video';
import { VideoLightbox } from './video-lightbox';
import { Select } from './select';
import { Datepicker } from './datepicker';
import { Login } from './login';
import { ServiceMenu } from './service-menu';
import { Slider } from './slider';
import { Tooltip } from './tooltip';
import { Accessory } from './accessory';
import { NumberInput } from './number-input';
import { EqualHeight } from './equal-height';
import { CartLine } from './cart-line';
import { Cart } from './cart';
import { EarlyPaymentDiscount } from './early-payment-discount';
import { ProductFilter } from './product-filter';
import { ProductSearch } from './product-search';
import { ProductTree } from './product-tree';
import { OrderLines } from './order-lines';
import { TimeoutBox } from './timeout-box';
import { Dropable } from './dropdown';
import { LeadManagement } from './lead-management';
import { DataTable } from './datatable';
import { BTEConfigurator } from './bte-configurator';
import { PAConfigurator } from './pa-configurator';
import { PageControls } from './pagecontrols';
import { VideoMatrix } from './videomatrix';
import { StickyMenu } from './stickymenu';
import { FullWidthCarousel } from './full-width-carousel';
import { HeroScroll } from './hero-scroll';
import { FeatureScroll } from './feature-scroll';
import { AudioPlayer } from './audio-player';
import { Modalify } from './modalify';
import { PageLoading } from './page-loading';
import { Progress } from './progress';
import { CheckboxFilter } from './checkboxFilter';
import { LoyaltyDashboard } from './loyalty-dashboard';
import { CourseView } from './course-view';
import { MyAchievements } from './my-achievements';
import { LMSRibbon } from './lms-ribbon';
import { NumbersOnly } from './numbers-only';
import { CurrencyFilter } from './currency-filter';
import { EnableButtonOnload } from './enable-button-onload';
import { RewardConfigurator } from './reward-configurator';
import { Checkout } from './checkout';
import { DataTableSpot } from './datatable-spot';
import { Warranty } from './warranty';
//import { Configurator } from './configurator';
import { ReturnForCredit } from './return-for-credit';
import { ProductDropdown } from './product-dropdown';
import { ProductSpot } from './product-spot';
import { ColorDropdown } from './color-dropdown'
import { ITEConfiguratorHCP } from './ite-configurator-hcp';
import { AccessoriesCarousel } from './accessories-carousel';
import { ProductPagination } from './product-pagination';
import { MegaMenuNavigation } from './mega-menu';
import { ProductFeatureSpot } from './product-feature-spot';
import { ExtraSalesModal } from './extra-sales-modal';
import { Multiselect } from './multiselect-dropdown';
import { PIMImage } from './pim-image';
import { FieldDepencencyController } from './field-dependency-controller';
import { MarketingCloudForms } from './marketing-cloud-forms';
import { BarcodeScanner } from './barcode-scanner'
import { Card } from './dtp/card'

export {
    MainNavigation,
    LanguageSelector,
    BackgroundMedia,
    SwiperContainer,
    Video,
    VideoLightbox,
    Select,
    Datepicker,
    Login,
    ServiceMenu,
    Slider,
    Tooltip,
    Accessory,
    NumberInput,
    EqualHeight,
    CartLine,
    Cart,
    EarlyPaymentDiscount,
    ProductFilter,
    ProductSearch,
    ProductTree,
    OrderLines,
    TimeoutBox,
    Dropable,
    LeadManagement,
    DataTable,
    BTEConfigurator,
    PAConfigurator,
    PageControls,
    VideoMatrix,
    StickyMenu,
    FullWidthCarousel,
    HeroScroll,
    FeatureScroll,
    AudioPlayer,
    Modalify,
    PageLoading,
    Progress,
    CheckboxFilter,
    LoyaltyDashboard,
    CourseView,
    MyAchievements,
    LMSRibbon,
    NumbersOnly,
    CurrencyFilter,
    EnableButtonOnload,
    Checkout,
    DataTableSpot,
    RewardConfigurator,
    ReturnForCredit,
    ProductDropdown,
    ProductSpot,
    ProductPagination,
    ProductFeatureSpot,
    MegaMenuNavigation,
    ColorDropdown,
    AccessoriesCarousel,
    ExtraSalesModal,
    ITEConfiguratorHCP,
    Warranty,
    PIMImage,
    Multiselect,
    FieldDepencencyController,
    MarketingCloudForms,
    BarcodeScanner,
    Card
};
